var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-header-item",class:{'cursor-pointer':!!_vm.sortName },style:(_vm.styleCustom),on:{"click":_vm.sortExecute}},[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div',{staticStyle:{"display":"flax"}},[(_vm.sortType==1)?_c('div',{staticClass:"asc"}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"5px"}}),_vm._v(" "),(_vm.sortType==0)?_c('div',{staticClass:"desc"}):_vm._e()])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee7c42c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-table/src/ui-table-header-item.vue
// module id = 688
// module chunks = 0